import gql from 'graphql-tag';

import { TeamMemberDetails } from '../fragments/team-members';

export const teamMember = gql`
  query teamMember($team_member_id: RecordID!, $token: String!) {
    teamMember(team_member_id: $team_member_id, token: $token) {
      ...TeamMemberDetails
    }
  }
  ${TeamMemberDetails}
`;
